@import (reference) '../../../../../constants/screen-width-breakpoints.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.enhanced-return-details-grid-container {
  padding: 0 @space-16 @space-16;
}

.enhanced-return-details-grid {
  flex: 1;
  display: grid;
  grid-gap: 16px;

  &.three-columns {
    grid-template: 'address-column rma-column cost-summary-column';
    grid-template-columns: minmax(0, 1fr) minmax(126px, max-content) 50%;
    grid-template-rows: auto;
  }

  &.two-columns {
    grid-template:
      'address-column rma-column'
      'cost-summary-column cost-summary-column';
    grid-template-columns: minmax(0, 1fr) 1fr;
    grid-template-rows: auto auto;
  }

  &.one-column {
    grid-template:
      'address-column'
      'rma-column'
      'cost-summary-column';
    grid-template-columns: auto;
    grid-template-rows: auto auto auto;
  }
}
